import { render, staticRenderFns } from "./cIntroduce.vue?vue&type=template&id=412ffc78&scoped=true&"
import script from "./cIntroduce.vue?vue&type=script&lang=js&"
export * from "./cIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./cIntroduce.vue?vue&type=style&index=0&id=412ffc78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412ffc78",
  null
  
)

export default component.exports